import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-6 ml-4" }
const _hoisted_2 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_3 = { class: "w-6/12 space-y-6" }
const _hoisted_4 = { class: "w-6/12 space-y-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, {
      label: _ctx.$t('partnerManagement.detail.contactInfo')
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_DataWrapper, {
          class: "w-full",
          label: _ctx.$t('partnerManagement.detail.name'),
          value: _ctx.detailData.partnerContactName
        }, null, 8, ["label", "value"]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.partnerContactPhoneNumber, (phone, index) => {
          return (_openBlock(), _createBlock(_component_DataWrapper, {
            key: index,
            class: "w-full",
            label: _ctx.$t('partnerManagement.detail.phone'),
            value: _ctx.formattedContactPhone(phone.no),
            "data-testid": `partner-detail-contact-phone-value-${index}`
          }, null, 8, ["label", "value", "data-testid"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_DataWrapper, {
          class: "w-full",
          label: _ctx.$t('partnerManagement.detail.jobTitle'),
          value: _ctx.detailData.partnerContactJobTitle
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          class: "w-full",
          label: _ctx.$t('partnerManagement.detail.email'),
          value: _ctx.detailData.partnerContactEmail
        }, null, 8, ["label", "value"])
      ])
    ])
  ]))
}